/**
 *  @type {User}
 */
export const userPlaceholder = {
	AccountType: "",
	Country: "",
	CustomerId: "",
	Email: "",
	EmailNotifications: {
		Billing: false,
		Device: false,
		Marketing: false,
	},
	Id: "",
	Locale: "en-GB",
	Phone: "",
	PushNotifications: {
		Enabled: false,
		Tokens: [],
	},
	SmsNotifications: {
		Balance: 0,
		Enabled: false,
	},
};
